import { render, staticRenderFns } from "./MwanPayment.vue?vue&type=template&id=1bd9e48e&scoped=true"
import script from "./MwanPayment.vue?vue&type=script&lang=js"
export * from "./MwanPayment.vue?vue&type=script&lang=js"
import style0 from "./MwanPayment.vue?vue&type=style&index=0&id=1bd9e48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9e48e",
  null
  
)

export default component.exports